import { MutableRefObject, useRef } from 'react';

import { IbUserAccountsAPIServiceTypes } from '../../services/IbUserAccountsServices/APIService';
import { IbUserAccountsAPIService } from '../../services/IbUserAccountsServices/APIService/index.api';
import { networkCallWithApisauceWithHeaders } from '../../utils/AuthAPIUtils';

import { useAccountsRefreshAuthTokens } from '../useAccountsRefreshAuthTokens';

const useIbUserAccountsAPIService = () => {
  const { refreshTokenApi, getAccessToken, getRefreshToken } =
    useAccountsRefreshAuthTokens();
  const IbUserAccountsAPIRef: MutableRefObject<IbUserAccountsAPIServiceTypes | null> =
    useRef(null);

  if (IbUserAccountsAPIRef.current === null) {
    IbUserAccountsAPIRef.current = new IbUserAccountsAPIService(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken,
        getRefreshToken
      })
    );
  }

  return {
    ibUserAccountsAPIService: IbUserAccountsAPIRef.current
  };
};

export { useIbUserAccountsAPIService };
